<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-row>
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-col :span="10">
              <el-form-item label="线路" prop="startDot">
                <el-cascader
                  :filterable="true"
                  :clearable="true"
                  style="width: 100%"
                  :options="options"
                  v-model="form.startDot"
                  @change="handleChangeStart"
                  :props="cityProps"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="4" class="arrow-box">
              <el-image :src="arrowImage" class="arrow-img"></el-image>
            </el-col>
            <el-col :span="10" style="padding-top: 0.3rem">
              <el-form-item prop="endDot">
                <el-cascader
                  :filterable="true"
                  :clearable="true"
                  style="width: 100%"
                  :options="options"
                  v-model="form.endDot"
                  @change="handleChangeEnd"
                  :props="cityProps"></el-cascader>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { addInfo, editInfo } from "./api";
import { getAreaNext } from "@/views/commonApi";
import { setAreaTree } from "@/utils";

export default {
  name: "AddOrEdit",
  components: { DialogContainer },
  data() {
    return {
      loading: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "添加/编辑线路",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: () => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      cityProps: {
        value: "areaCode",
        label: "areaExtName",
        checkStrictly: true,
      },
      form: {
        lineId: "",
        endCityCode: "",
        endCityName: "",
        endProvinceCode: "",
        endProvinceName: "",
        startCityCode: "",
        startCityName: "",
        startProvinceCode: "",
        startProvinceName: "",
        startDot: [],
        endDot: [],
      },
      rules: {
        startDot: [{ required: true, message: "线路起点不能为空" }],
        endDot: [{ required: true, message: "线路终点不能为空" }],
      },
      arrowImage: require("@/assets/imgs/arroy.png"),
      areaTree: [],
    };
  },
  computed: {
    options() {
      const treeData = JSON.parse(localStorage.getItem("area")) || [];
      this.areaTree = setAreaTree(treeData, 1, 2);
      return this.areaTree;
    },
  },
  methods: {
    // 根据code 递归查找节点
    findNodeByCode(code, nodes) {
      for (const node of nodes) {
        if (node.areaCode == code) return node;
        if (node.children && node.children.length) {
          const res = this.findNodeByCode(code, node.children);
          if (res) return res;
        }
      }
      return null;
    },

    // 起点
    handleChangeStart() {
      const [provCode, cityCode] = this.form.startDot || [];
      if (!provCode || !cityCode) {
        this.form.startProvinceCode = "";
        this.form.startProvinceName = "";
        this.form.startCityCode = "";
        this.form.startCityName = "";
        return;
      }

      const prov = this.findNodeByCode(provCode, this.areaTree);
      const city = this.findNodeByCode(cityCode, this.areaTree);

      this.form.startProvinceCode = provCode;
      this.form.startProvinceName = prov?.areaExtName || "";
      this.form.startCityCode = cityCode;
      this.form.startCityName = city?.areaExtName || "";
    },

    // 终点
    handleChangeEnd() {
      const [provCode, cityCode] = this.form.endDot || [];
      if (!provCode || !cityCode) {
        this.form.endProvinceCode = "";
        this.form.endProvinceName = "";
        this.form.endCityCode = "";
        this.form.endCityName = "";
        return;
      }

      const prov = this.findNodeByCode(provCode, this.areaTree);
      const city = this.findNodeByCode(cityCode, this.areaTree);

      this.form.endProvinceCode = provCode;
      this.form.endProvinceName = prov?.areaExtName || "";
      this.form.endCityCode = cityCode;
      this.form.endCityName = city?.areaExtName || "";
    },

    init(row) {
      if (row) {
        this.form.startDot = [row.startProvinceCode, row.startCityCode];
        this.form.endDot = [row.endProvinceCode, row.endCityCode];
        this.form.lineId = row.lineId;
        this.form.startProvinceCode = row.startProvinceCode;
        this.form.startProvinceName = row.startProvinceName;
        this.form.startCityCode = row.startCityCode;
        this.form.startCityName = row.startCityName;
        this.form.endProvinceCode = row.endProvinceCode;
        this.form.endProvinceName = row.endProvinceName;
        this.form.endCityCode = row.endCityCode;
        this.form.endCityName = row.endCityName;
        this.dialogObj.title = "编辑线路";
      } else {
        this.dialogObj.title = "添加线路";
        this.form = this.$options.data().form;
      }
      this.dialogObj.show = true;
    },

    getDetail(lineId) {
      this.loading = true;
      detailInfo(lineId).then(res => {
        if (res.code === 200) {
          const d = res.data;
          this.form.lineId = d.lineId;
          this.form.startDot = [d.startProvinceCode, d.startCityCode];
          this.form.endDot = [d.endProvinceCode, d.endCityCode];
          this.form.startProvinceCode = d.startProvinceCode;
          this.form.startProvinceName = d.startProvinceName;
          this.form.startCityCode = d.startCityCode;
          this.form.startCityName = d.startCityName;
          this.form.endProvinceCode = d.endProvinceCode;
          this.form.endProvinceName = d.endProvinceName;
          this.form.endCityCode = d.endCityCode;
          this.form.endCityName = d.endCityName;
        }
        this.loading = false;
      });
    },

    // 提交
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;

        // 提交前 强制刷新赋值（终极保险）
        this.handleChangeStart();
        this.handleChangeEnd();

        this.dialogObj.btnLoading = true;
        const api = this.form.lineId ? editInfo : addInfo;

        const params = {
          lineId: this.form.lineId,
          startProvinceCode: this.form.startProvinceCode,
          startProvinceName: this.form.startProvinceName,
          startCityCode: this.form.startCityCode,
          startCityName: this.form.startCityName,
          endProvinceCode: this.form.endProvinceCode,
          endProvinceName: this.form.endProvinceName,
          endCityCode: this.form.endCityCode,
          endCityName: this.form.endCityName,
        };

        api(params).then(res => {
          this.dialogObj.btnLoading = false;
          if (res.code === 200) {
            this.$message.success(this.form.lineId ? "编辑成功" : "添加成功");
            this.$parent.handleAddOrEditSuccess(this.form.lineId ? "edit" : "add");
            this.dialogObj.beforeClose();
          }
        }).catch(() => {
          this.dialogObj.btnLoading = false;
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .arrow-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .arrow-img {
    width: 0.48rem;
    height: 0.05rem;
    position: relative;
    top: 0.45rem;
  }
}
</style>
